import db from '@/db'

export default {
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    if (this.user && this.user.selectedOrganization && this.$route.query.s) {
      let org
      this.$route.query.s === '1' ? org = this.user.selectedOrganization : org = this.$route.query.s
      this.$store.dispatch('setOrganizationRef', db.collection('organization').doc(org))
    }
  }
}
